import { render } from "./LoadingContainer.vue?vue&type=template&id=463c1dbe"
import script from "./LoadingContainer.vue?vue&type=script&lang=js"
export * from "./LoadingContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__